// "Only my areas" on the client contacts: which contact sections belong to
// the work a staff member does on a company.

// Function → contact sections it works with. CONTROL and ADMIN touch every
// area, so they are absent here and turn the filter off.
export const FUNCTION_CONTACT_SECTIONS = {
  PAYROLL: ['PAYROLL'],
  BOOKKEEPING: ['BOOKKEEPING', 'INVOICES'],
  PAYMENTS: ['PAYMENTS'],
  REPORTS: ['REPORTS'],
};

export const ONLY_MY_AREAS_KEY = 'hlb.teamContacts.onlyMyAreas';

/**
 * Sections of the viewer's current assignments on one company, or null when
 * nothing should be filtered: managers, no HLB employee record, no assignment
 * on the company, or a function that spans all areas (CONTROL, ADMIN).
 */
export const mySectionsFor = ({
  rows = [],
  me,
  companyId,
  canManage = false,
}) => {
  if (canManage || !me) return null;
  const fns = [
    ...new Set(
      rows
        .filter((a) => a.employee === me && a.company === companyId)
        .map((a) => a.function)
    ),
  ];
  if (!fns.length || fns.some((fn) => !FUNCTION_CONTACT_SECTIONS[fn]))
    return null;
  return new Set(fns.flatMap((fn) => FUNCTION_CONTACT_SECTIONS[fn]));
};

/** Contacts with at least one of the sections; all of them when sections is null. */
export const filterContactsBySections = (contacts = [], sections) =>
  sections
    ? contacts.filter((c) =>
        (c.sections || []).some((s) => sections.has(s.section))
      )
    : contacts;

export const readOnlyMyAreas = () => {
  try {
    return localStorage.getItem(ONLY_MY_AREAS_KEY) === '1';
  } catch {
    return false;
  }
};

export const storeOnlyMyAreas = (on) => {
  try {
    localStorage.setItem(ONLY_MY_AREAS_KEY, on ? '1' : '0');
  } catch {
    // storage unavailable: the choice lasts until the page is left
  }
};
